import * as type from "../../types/API/itemSeries";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const itemSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_ITEM_SERIES:
      return {
        ...state,
        loading: true,
      };
    case type.GET_ITEM_SERIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_ITEM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addItemSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_ITEM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_ITEM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_ITEM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editItemSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.EDIT_ITEM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_ITEM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_ITEM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteItemSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_ITEM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_ITEM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_ITEM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateLastItemNumberReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_LAST_ITEM_NUMBER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.UPDATE_LAST_ITEM_NUMBER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_LAST_ITEM_NUMBER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const setDefaultItemSeriesReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.SET_DEFAULT_ITEM_SERIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.SET_DEFAULT_ITEM_SERIES_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.SET_DEFAULT_ITEM_SERIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
